if (!customElements.get('show-more-content')) {
	class ShowMoreContent extends HTMLElement {
		connectedCallback() {
			this.content = this.querySelector('[data-show-more-content]')
			this.toggleButton = this.querySelector('[data-show-more-toggle]')

			if (!this.content || !this.toggleButton) return

			this.expandedClass = 'is-expanded'
			this.overflowingClass = 'is-overflowing'
			this.isExpanded = false

			this.onToggleClick = this.onToggleClick.bind(this)
			this.onTransitionEnd = this.onTransitionEnd.bind(this)
			this.checkOverflow = this.checkOverflow.bind(this)

			this.toggleButton.addEventListener('click', this.onToggleClick)
			this.content.addEventListener('transitionend', this.onTransitionEnd)

			this.collapse(false)
			this.checkOverflow()

			if ('ResizeObserver' in window) {
				this.resizeObserver = new ResizeObserver(this.checkOverflow)
				this.resizeObserver.observe(this.content)
			}

			if (window.FoxThemeEvents && typeof window.FoxThemeEvents.subscribe === 'function') {
				this.tabOpenedUnsubscriber = window.FoxThemeEvents.subscribe(
					'ON_COLLAPSIBLE_TAB_OPENED',
					() => this.checkOverflow()
				)
			}

			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(this.checkOverflow)
			}
		}

		disconnectedCallback() {
			this.toggleButton && this.toggleButton.removeEventListener('click', this.onToggleClick)
			this.content && this.content.removeEventListener('transitionend', this.onTransitionEnd)
			this.resizeObserver && this.resizeObserver.disconnect()
			this.tabOpenedUnsubscriber && this.tabOpenedUnsubscriber()
		}

		get maxHeight() {
			const value = parseInt(this.dataset.maxHeight, 10)
			return isNaN(value) ? 120 : value
		}

		// Hide the toggle when the content is short enough to be fully visible.
		checkOverflow() {
			if (this.isExpanded) return

			const overflowing = this.content.scrollHeight > this.maxHeight + 1
			this.classList.toggle(this.overflowingClass, overflowing)
			this.toggleButton.hidden = !overflowing
		}

		onToggleClick(event) {
			event.preventDefault()
			this.isExpanded ? this.collapse(true) : this.expand()
		}

		expand() {
			this.isExpanded = true
			this.classList.add(this.expandedClass)
			this.content.style.maxHeight = `${this.content.scrollHeight}px`
			this.setLabels()
		}

		collapse(animate) {
			this.isExpanded = false
			this.classList.remove(this.expandedClass)

			if (animate) {
				this.content.style.maxHeight = `${this.content.scrollHeight}px`
				// Force a reflow so the browser animates from the current height.
				this.content.offsetHeight // eslint-disable-line no-unused-expressions
			}

			this.content.style.maxHeight = `${this.maxHeight}px`
			this.setLabels()
		}

		// Once expanded, drop the inline max-height so later content changes are not clipped.
		onTransitionEnd(event) {
			if (event.target !== this.content || event.propertyName !== 'max-height') return
			if (this.isExpanded) this.content.style.maxHeight = 'none'
		}

		setLabels() {
			const moreLabel = this.querySelector('[data-show-more-text]')
			const lessLabel = this.querySelector('[data-show-less-text]')

			this.toggleButton.setAttribute('aria-expanded', this.isExpanded ? 'true' : 'false')
			if (moreLabel) moreLabel.hidden = this.isExpanded
			if (lessLabel) lessLabel.hidden = !this.isExpanded
		}
	}

	customElements.define('show-more-content', ShowMoreContent)
}
